// In-place text editor opened by double-clicking a text element on the page.

import React, { useEffect, useRef } from "react";
import { IconButton } from "../controls";
import RunsEditor from "../RunsEditor";

export default function TextPopover({ el, ctx, style, onChange, onClose }) {
  const ref = useRef(null);
  useEffect(() => {
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    // Defer so the double-click that opened us doesn't close us.
    const t = setTimeout(() => document.addEventListener("pointerdown", onDown), 0);
    return () => {
      clearTimeout(t);
      document.removeEventListener("pointerdown", onDown);
    };
  }, [onClose]);
  return (
    <div
      ref={ref}
      className="td-popover td-textpop"
      style={style}
      role="dialog"
      aria-label="Edit text"
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          e.stopPropagation();
          onClose();
        }
      }}
    >
      <div className="td-textpop__head">
        <span className="td-label">Edit text</span>
        <IconButton icon="x" label="Close" onClick={onClose} size={14} />
      </div>
      <RunsEditor
        runs={el.runs}
        onChange={onChange}
        fieldGroups={ctx.docFieldGroups}
        labels={ctx.labels}
        kinds={ctx.kinds}
        formats={ctx.formats}
        palette={ctx.palette}
        rows={4}
        autoFocus
        label="Text"
      />
    </div>
  );
}
